window.Sparkle ??= {};
window.Sparkle.PageBuilder ??= {};
window.Sparkle.PageBuilder.Component ??= {};
window.Sparkle.PageBuilder.Component.ActionBar ??= {};

Sparkle.PageBuilder.Component.ActionBar.Action = class Action {
  constructor(name, options) {
    this.render = this.render.bind(this);
    this.visible = this.visible.bind(this);
    this.name = name;
    this.options = options;
    this.el = jQuery('<span class="component-action"></span>').attr("data-action", this.name);

    // BEHAVIOUR

    if (this.options.callback) {
      this.el.on("click", this.options.callback);
    }
  }

  render() {
    this.el.attr("title", this.options.tooltip);
    if (typeof this.options.icon === "function") {
      this.el.append(this.options.icon());
    } else {
      this.el.append(this.options.icon);
    }

    return this;
  }

  // DSL

  visible() {
    if (this.options.condition) {
      return this.options.condition();
    } else {
      return true;
    }
  }
};
